import React from 'react'
import styled from 'styled-components'
import { P, H, Image, BackgroundImageWrapper, Wrapper } from '@farewill/ui'
import { screenMin } from '@farewill/ui/helpers/responsive'
import { COLOR, GTR } from '@farewill/ui/tokens'

import data from './data'

const StyledWrapperFlex = styled(Wrapper)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
`

const StyledWrapperFlexItemSmall = styled(Wrapper)`
  flex: 0 1 25%;
`

const StyledWrapperFlexItemLarge = styled(Wrapper)`
  flex: 1 0 390px;
`

const StyledWrapperFlexColumn = styled(Wrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
`

const StyledWrapperFlexColumnSpaceBetween = styled(StyledWrapperFlexColumn)`
  justify-content: space-between;
`

const StyledWrapperFlexColumnCenter = styled(StyledWrapperFlexColumn)`
  justify-content: center;
`

const StyledWrapperFlexColumnItem = styled(Wrapper)`
  width: 100%;
  margin-bottom: 60px;

  ${screenMin.xl`
    margin-bottom: ${GTR.L};
  `}
`

const StyledBackgroundImageWrapper = styled(BackgroundImageWrapper)`
  background-size: contain;
`

const StyledBubbleSmall = styled(Wrapper)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const DesktopComponent = (): React.ReactElement => (
  <StyledWrapperFlex>
    <StyledWrapperFlexItemSmall>
      <StyledWrapperFlexColumnSpaceBetween>
        <StyledWrapperFlexColumnItem
          margin={[0, `-${GTR.L}`, 60, 'L']}
          marginFromXL={[0, `-${GTR.L}`, 'L', 'L']}
        >
          <StyledBackgroundImageWrapper
            imagePath="textures/speech-bubble-left"
            imageWidth={263}
            backgroundPosition="50% 50%"
            padding={['XXL', 'XL']}
            paddingFromXL="XXL"
          >
            <StyledBubbleSmall centered>
              <Image
                path={data.bubble1.image}
                width={120}
                widthFromL={160}
                widthFromXL={200}
              />
              <P maxWidth={184} margin={['S', 'auto']}>
                {data.bubble1.content}
              </P>
            </StyledBubbleSmall>
          </StyledBackgroundImageWrapper>
        </StyledWrapperFlexColumnItem>
        <StyledWrapperFlexColumnItem
          margin={[0, `-${GTR.S}`, 60, 'S']}
          marginFromXL={[0, `-${GTR.S}`, 'L', 'S']}
        >
          <StyledBackgroundImageWrapper
            imagePath="textures/speech-bubble-right"
            imageWidth={263}
            backgroundPosition="50% 50%"
            padding={['XXL', 'XL']}
            paddingFromXL="XXL"
          >
            <StyledBubbleSmall centered>
              <Image
                path={data.bubble2.image}
                width={120}
                widthFromL={160}
                widthFromXL={200}
              />
              <P maxWidth={184} margin={['S', 'auto']}>
                {data.bubble2.content}
              </P>
            </StyledBubbleSmall>
          </StyledBackgroundImageWrapper>
        </StyledWrapperFlexColumnItem>
      </StyledWrapperFlexColumnSpaceBetween>
    </StyledWrapperFlexItemSmall>
    <StyledWrapperFlexItemLarge>
      <StyledWrapperFlexColumnCenter>
        <StyledWrapperFlexColumnItem>
          <StyledBackgroundImageWrapper
            imagePath="textures/blob-yellow-3"
            imageWidth={367}
            backgroundPosition="50% 50%"
            padding={['XXL', 'L']}
            paddingFromXL="XXL"
          >
            <StyledBubbleSmall centered>
              <Image path="illustrations/lightbulb" width={145} />
              <H maxWidth={261} size="S" tag="h3">
                {data.yellowBlobTitle}
              </H>
              <P maxWidth={261} margin={[0, 'auto', 'S']} color={COLOR.BLACK}>
                {data.yellowBlobDescription}
              </P>
            </StyledBubbleSmall>
          </StyledBackgroundImageWrapper>
        </StyledWrapperFlexColumnItem>
      </StyledWrapperFlexColumnCenter>
    </StyledWrapperFlexItemLarge>
    <StyledWrapperFlexItemSmall>
      <StyledWrapperFlexColumnSpaceBetween>
        <StyledWrapperFlexColumnItem>
          <StyledBackgroundImageWrapper
            imagePath="textures/speech-bubble-left"
            imageWidth={263}
            backgroundPosition="50% 50%"
            padding={['XXL', 'XL']}
            paddingFromXL="XXL"
          >
            <StyledBubbleSmall centered>
              <Image
                path={data.bubble3.image}
                width={120}
                widthFromL={160}
                widthFromXL={200}
              />
              <P maxWidth={184} margin={['S', 'auto']}>
                {data.bubble3.content}
              </P>
            </StyledBubbleSmall>
          </StyledBackgroundImageWrapper>
        </StyledWrapperFlexColumnItem>
        <StyledWrapperFlexColumnItem
          margin={[0, `-${GTR.L}`, 60, 'L']}
          marginFromXL={[0, `-${GTR.L}`, 'L', 'L']}
        >
          <StyledBackgroundImageWrapper
            imagePath="textures/speech-bubble-right"
            imageWidth={263}
            backgroundPosition="50% 50%"
            padding={['XXL', 'XL']}
            paddingFromXL="XXL"
          >
            <StyledBubbleSmall centered>
              <Image
                path={data.bubble4.image}
                width={120}
                widthFromL={160}
                widthFromXL={200}
              />
              <P maxWidth={184} margin={['S', 'auto']}>
                {data.bubble4.content}
              </P>
            </StyledBubbleSmall>
          </StyledBackgroundImageWrapper>
        </StyledWrapperFlexColumnItem>
      </StyledWrapperFlexColumnSpaceBetween>
    </StyledWrapperFlexItemSmall>
  </StyledWrapperFlex>
)

export default DesktopComponent
